module.exports = __webpack_public_path__ + "img/verification.e3997eb4.svg";